import React, { forwardRef } from 'react';
import MuiList, { ListProps as MuiListProps } from '@mui/material/List';
import { BpDesignSystem } from '../../types';

export type ListProps = BpDesignSystem.PropsWithChildren<MuiListProps & { ariaLabel?: string }>;

// This is ex-MenuList component
export const List = forwardRef<HTMLUListElement, ListProps>(({ component, dataTest, ariaLabel, ...rest }, ref) => (
  <MuiList
    component={component ?? 'nav'}
    aria-label={ariaLabel ?? 'oc-list'}
    data-test={dataTest ?? 'list'}
    {...rest}
    ref={ref}
  />
));
